// extracted by mini-css-extract-plugin
module.exports = {"title":"landingPage_title__3yovk","contenedor":"landingPage_contenedor__397co","form__submit":"landingPage_form__submit__Q4yo5"};